module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="generic-states"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlGenericStates", "Generic" ) ))==null?'':__t)+
'</h5></header><p v-if="model.modelError" class="error">ERROR! {{ model.modelError }}</p><dl data-region="generic-state-container"><dt data-text="context-header" class="module-title"> '+
((__t=( i18n.tc("PortableBaseTest", "Battery voltage")))==null?'':__t)+
'</dt><dd class="battery-voltage" :class="batteryVoltageStatus">{{ batteryVoltage }}</dd><dd><i class="icon icon-material battery-level" v-bind:class="batteryLvl"></i></dd></dl></div>';
}
return __p;
};
